module.exports = __webpack_public_path__ + "static/media/kellyruigrok.c13e98f5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/kellyruigrok.webp
// module id = 694
// module chunks = 0